import { useTranslation } from 'react-i18next';

import { NumberInput } from 'components/Inputs';

import OwnerRadio from './OwnerRadio';

interface ShareSectionProps {
  idPrefix: string;
  control: any;
  watch: any;
  setValue: any;
  errors: any;
  disabled?: boolean;
}

const ShareSection: React.FC<ShareSectionProps> = ({
  idPrefix,
  control,
  watch,
  setValue,
  errors,
  disabled = false,
}) => {
  const { t } = useTranslation('ownership');

  return (
    <div className="border-t border-gray-200 mt-6 pt-6">
      <OwnerRadio
        idPrefix={`isOver20-${idPrefix}`}
        label={t('ownership:fields.shareQuestion.label')}
        options={[
          { value: false, name: t('ownership:fields.shareQuestion.no') },
          { value: true, name: t('ownership:fields.shareQuestion.yes') },
        ]}
        value={watch('isOver20')}
        onChange={(value) =>
          setValue('isOver20', value, { shouldValidate: true })
        }
        error={errors?.isOver20}
        disabled={disabled}
      />

      <NumberInput
        name="ownershipPercentage"
        label={t('ownership:fields.ownershipPercentage.label')}
        placeholder={t('ownership:fields.ownershipPercentage.placeholder')}
        readOnly={disabled}
        className="w-full sm:w-1/2 mt-6"
        inputClassName="pl-8"
        prefix="%"
        prefixInline
        allowNegative={false}
        control={control}
        error={errors?.ownershipPercentage}
      />
    </div>
  );
};

export default ShareSection;
